import * as React from 'react';
import { pathOr } from 'ramda';

import { BuilderHousesLink } from './BuilderHousesLink';
import { ContactsContainer } from './Contacts';
import { trackTransferToDeveloperCard } from './tracking';
import { Builder } from '../../components/Builder';
import { InfoLink } from '../../components/Builder/component/BuilderLinkBlock/InfoLink';
import { IBuilder } from '../../types/newbuilding/builder';
import { trackAgentFlatsLinkClick } from '../Offers/tracking';

interface IBuilderContainerProps {
  builder: IBuilder;
}

export function BuilderContainer({ builder }: IBuilderContainerProps) {
  const {
    logoUrl,
    name,
    profileUrl,
    yearOfFoundation,
    stats,
    reviewStats,
    isReliable,
    offersForSaleText,
    offersForSaleUrl,
  } = builder;
  const doneStats = pathOr(null, ['done'], stats);
  const inProgressStats = pathOr(null, ['inProgress'], stats);

  return (
    <Builder
      logoUrl={logoUrl}
      name={name}
      yearOfFoundation={yearOfFoundation}
      done={<BuilderHousesLink stats={doneStats} type="done" />}
      inProgress={<BuilderHousesLink stats={inProgressStats} type="inProgress" />}
      offersForSale={<InfoLink url={offersForSaleUrl} text={offersForSaleText} onClick={trackAgentFlatsLinkClick} />}
      developerCard={
        <InfoLink url={profileUrl} text="Подробнее о застройщике" onClick={trackTransferToDeveloperCard} />
      }
      url={profileUrl}
      onBuilderLinkClick={trackTransferToDeveloperCard}
      reviewStats={reviewStats}
      isReliable={isReliable}
      contacts={<ContactsContainer builder={builder} />}
    />
  );
}
